import { render, staticRenderFns } from "./dataTable.vue?vue&type=template&id=5eba949c&scoped=true&"
import script from "./dataTable.vue?vue&type=script&lang=js&"
export * from "./dataTable.vue?vue&type=script&lang=js&"
import style0 from "./dataTable.vue?vue&type=style&index=0&id=5eba949c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eba949c",
  null
  
)

export default component.exports